import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import statisticService from '../../../services/statistics';
import sellerStatisticService from '../../../services/seller/statistics';
import moment from 'moment';

const initialState = {
  loading: false,
  counts: [],
  error: '',
  params: {
    time: 'subMonth',
  },
};

// Helper function to build API params with proper priority
const buildApiParams = (params = {}) => {
  const apiParams = { ...params };
  
  // If date_from is provided, use date range and remove time
  if (apiParams.date_from) {
    apiParams.date_to = apiParams.date_to || moment().format('YYYY-MM-DD');
    delete apiParams.time;
  } else if (!apiParams.time) {
    // Default to subMonth if neither date_from nor time is provided
    apiParams.time = 'subMonth';
  }
  
  return apiParams;
};

export const fetchOrderCounts = createAsyncThunk(
  'statistics/fetchOrderCounts',
  (params = {}) => {
    const apiParams = buildApiParams({ ...initialState.params, ...params });
    return statisticService.ordersCount(apiParams).then((res) => res);
  }
);

export const fetchSellerOrderCounts = createAsyncThunk(
  'statistics/fetchSellerOrderCounts',
  (params = {}) => {
    const apiParams = buildApiParams({ ...initialState.params, ...params });
    return sellerStatisticService.ordersCount(apiParams).then((res) => res);
  }
);

const orderCountSlice = createSlice({
  name: 'orderCount',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchOrderCounts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOrderCounts.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.counts = payload.data;
      state.error = '';
    });
    builder.addCase(fetchOrderCounts.rejected, (state, action) => {
      state.loading = false;
      state.counts = [];
      state.error = action.error.message;
    });

    builder.addCase(fetchSellerOrderCounts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSellerOrderCounts.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.counts = payload.data;
      state.error = '';
    });
    builder.addCase(fetchSellerOrderCounts.rejected, (state, action) => {
      state.loading = false;
      state.counts = [];
      state.error = action.error.message;
    });
  },
  reducers: {
    filterOrderCounts(state, action) {
      const { payload } = action;
      state.params = payload;
    },
  },
});
export const { filterOrderCounts } = orderCountSlice.actions;
export default orderCountSlice.reducer;
